import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ light = false }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith('ar') ? 'ar' : 'fr';

  const toggle = () => {
    const next = currentLang === 'fr' ? 'ar' : 'fr';
    i18n.changeLanguage(next);
  };

  return (
    <button
      onClick={toggle}
      data-testid="language-switcher-btn"
      aria-label="Switch language"
      className={`flex items-center gap-1.5 text-sm font-medium px-3 py-1.5 rounded-full border transition-all hover:scale-105 ${
        light
          ? 'text-white border-white/30 hover:bg-white/10'
          : 'text-gray-700 border-gray-200 hover:border-blue-400 hover:text-blue-600'
      }`}
    >
      <Globe size={16} />
      <span className="font-semibold">{currentLang === 'fr' ? 'العربية' : 'Français'}</span>
    </button>
  );
};

export default LanguageSwitcher;
